module.exports = __webpack_public_path__ + "static/media/support_agent.34a7db4d.svg";